import axios from 'axios';
import {API_URL_PREFIX, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/schedule';

class ScheduleService {
    // no header needed
    getSchedule() {
        return axios.get(API_URL).catch(function (error) {
            axiosErrorHandler(error);
        });
    }
    // no header needed
    getAllSchedule() {
        return axios.get(API_URL + "/all").catch(function (error) {
            axiosErrorHandler(error);
        });
    }
}

export default new ScheduleService();
